import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';

const createReactClass = require('create-react-class');

const safetyStatusDictionary = {
  A: 'Active',
  S: 'Safe',
  E: 'Expired',
  D: 'Deleted'
};
const LifelineSearchInterface = createReactClass({
  getInitialState() {
    return {
      lifelines: [],
      errorMessage: null,
      showReset: false
    };
  },

  retrieveUser() {
    const inputData = this.refs['user-search-input'].value;
    const options = {};
    if (inputData.match(/^\d+$/)) {
      options.user_id = inputData;
    } else if (inputData.indexOf('@')) {
      options.email = inputData;
    }

    this.setState({ lifelines: [], errorMessage: null });
    ServerCommunicationUtil.getApiEndpoint(
      '/api/alltrails/lifeline_search',
      options,
      function(data) {
        this.handleResults(data);
      }.bind(this),
      function(data) {
        this.setState({ lifelines: [], errorMessage: 'Found no active user' });
      }.bind(this),
      function() {}
    );
  },
  handleResults(data) {
    if (data.lifeline_searches && data.lifeline_searches.length > 0) {
      this.setState({ lifelines: data.lifeline_searches });
    } else {
      this.setState({ errorMessage: 'User has no lifeline history' });
    }
  },
  render() {
    let statusText = null;
    if (this.state.errorMessage !== null) {
      statusText = <p className="user-info-centered feedback-text">{this.state.errorMessage}</p>;
    }

    let displayContainer;
    if (this.state.lifelines.length > 0) {
      const lifelineDivs = [];
      const { user } = this.state.lifelines[0];
      for (let i = this.state.lifelines.length - 1; i >= 0; i--) {
        const currentSession = this.state.lifelines[i];
        let formattedStart = new Date(currentSession.startTime);
        formattedStart = formattedStart.toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
        let formattedEnd = new Date(currentSession.endTime);
        formattedEnd = formattedEnd.toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });

        lifelineDivs.push(
          <tr>
            <td>{currentSession.id}</td>
            <td>{formattedStart}</td>
            <td>{formattedEnd}</td>
            <td>{safetyStatusDictionary[currentSession.metadata.status]}</td>
            <td>
              <a href={`/lifelines/${currentSession.uuid}`} target="_blank">
                Link
              </a>
            </td>
          </tr>
        );
      }
      displayContainer = (
        <div>
          <h3>{`${user.firstName} ${user.lastName}'s Lifeline History`}</h3>
          <table className="lifeline-history">
            <tr>
              <th>Lifeline ID</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Status</th>
              <th>Link</th>
            </tr>
            {lifelineDivs}
          </table>
        </div>
      );
    }

    return (
      <div className="edition-details">
        <div className="trail-edit-form">
          <div className="field clear contains-separator">
            <div className="floatleft user-info-centered">
              <div>
                <label>Find Lifelines for this user:</label>
                <input ref="user-search-input" placeholder="Enter email or user Id" className="email-inputs" />
              </div>
              <div className="btn green rounded simple" onClick={this.retrieveUser}>
                Find User
              </div>
            </div>
          </div>
          {statusText}
          {displayContainer}
        </div>
      </div>
    );
  }
});

export { LifelineSearchInterface };
